import { ThemeProvider as ThemeMuiProvider, GlobalStyles } from "@mui/material";
import ChatWrapper from "./components/ChatWrapper";
import { ThemeProvider, WebSocketProvider, useThemeContext } from "./context/Theme";

const ThemeCheck: React.FC = () => {
  const { loaded, theme } = useThemeContext();

  return loaded ? (
    <ThemeMuiProvider theme={theme}>
      <GlobalStyles styles={{ 
        ".whatsapp-btn": { display: "none !important" },
        "#chat-root": {
          maxWidth: "800px",
          margin: "0 auto",
          position: "fixed",
          bottom: "2vh",
          right: "2vw",
          zIndex: "9999",
          fontFamily: "'Roboto', sans-serif",
          height: "80vh"
        },
        "#chat-root *": {
          fontFamily: "'Roboto', sans-serif !important",
          fontSize: "16px",
        }
      }} />
      <ChatWrapper />
    </ThemeMuiProvider>
  ) : null;
};

const App: React.FC = () => {
  return (
    <WebSocketProvider>
      <ThemeProvider>
        <ThemeCheck />
      </ThemeProvider>
    </WebSocketProvider>
  );
};

export default App;
